import React from "react";
import { createContext, useContext, useState } from "react";

const MapOptionsContext = createContext(undefined);

export const MapOptionsProvider = ({ children }) => {
  const [mapOptions, setMapOptions] = useState({
    locationMap: {
      zoom: null,
      center: {
        lat: null,
        lng: null,
      }
    },
    isStreetView: false,
  });

  return (
    <MapOptionsContext.Provider
      value={{
        mapOptions,
        setMapOptions,
      }}>
      {children}
    </MapOptionsContext.Provider>
  );
};

export const useMapOptions = () => {
  const context = useContext(MapOptionsContext);
  if (!context) {
    throw new Error("useMapOptions must be used within an MapOptionsProvider");
  }
  return context;
};
